/**
 * Configure pdf.js worker once (Vite bundles `pdf.worker.mjs` via `?url`).
 * Same pattern as `owlbert-electron/src/renderer/lib/readFileForUserDocument.ts`.
 */
import { GlobalWorkerOptions } from 'pdfjs-dist'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url'

if (typeof GlobalWorkerOptions.workerSrc === 'undefined' || !GlobalWorkerOptions.workerSrc) {
  GlobalWorkerOptions.workerSrc = pdfWorkerUrl
}
